import { render } from "./packetJoin.vue?vue&type=template&id=425efb9d&scoped=true"
import script from "./packetJoin.vue?vue&type=script&lang=js"
export * from "./packetJoin.vue?vue&type=script&lang=js"

import "./packetJoin.vue?vue&type=style&index=0&id=425efb9d&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425efb9d"]])

export default __exports__